import { render, staticRenderFns } from "./XForm.vue?vue&type=template&id=36a3ed6c&"
import script from "./XForm.vue?vue&type=script&lang=js&"
export * from "./XForm.vue?vue&type=script&lang=js&"
import style0 from "./XForm.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports